module.exports = __webpack_public_path__ + "components/country-flag/static/ci-fac65ca850541c66915e1c747fc5e800.svg";